const ANALYTICS_URL = '/api/app/v1/analytics/event';

export interface TrackEventPayload {
  event_type: string;
  page_path?: string;
  page_url?: string;
  referrer?: string;
  entity_type?: string;
  entity_id?: string;
  event_target?: string;
  event_location?: string;
  event_value?: string;
  properties?: Record<string, unknown>;
  occurred_at?: string;
}

export function trackEvent(payload: TrackEventPayload): void {
  const body = JSON.stringify({
    ...payload,
    occurred_at: payload.occurred_at ?? new Date().toISOString(),
  });

  fetch(ANALYTICS_URL, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    credentials: 'include',
    body,
  }).catch(() => {
    // fire-and-forget — ignore errors
  });
}
